import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ToastComponent } from "./chunk-7WY3NOY6.mjs";
import { toastStore } from "./chunk-RANSABEB.mjs";
import { getToastListStyle } from "./chunk-5XWPESX6.mjs";

// src/toast.provider.tsx
import { AnimatePresence } from "framer-motion";
import { Portal } from "@chakra-ui/portal";
import { useSyncExternalStore } from "react";
import { createContext } from "@chakra-ui/react-context";
import { jsx } from "react/jsx-runtime";
var _createContext = createContext({
    name: "ToastOptionsContext",
    strict: false
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  ToastOptionProvider = _createContext2[0],
  useToastOptionContext = _createContext2[1];
var ToastProvider = function ToastProvider(props) {
  var state = useSyncExternalStore(toastStore.subscribe, toastStore.getState, toastStore.getState);
  var motionVariants = props.motionVariants,
    _props$component = props.component,
    Component = _props$component === void 0 ? ToastComponent : _props$component,
    portalProps = props.portalProps;
  var stateKeys = Object.keys(state);
  var toastList = stateKeys.map(function (position) {
    var toasts = state[position];
    return /* @__PURE__ */jsx("ul", {
      role: "region",
      "aria-live": "polite",
      id: "chakra-toast-manager-".concat(position),
      style: getToastListStyle(position),
      children: /* @__PURE__ */jsx(AnimatePresence, {
        initial: false,
        children: toasts.map(function (toast) {
          return /* @__PURE__ */jsx(Component, _objectSpread({
            motionVariants: motionVariants
          }, toast), toast.id);
        })
      })
    }, position);
  });
  return /* @__PURE__ */jsx(Portal, _objectSpread(_objectSpread({}, portalProps), {}, {
    children: toastList
  }));
};
export { ToastOptionProvider, useToastOptionContext, ToastProvider };